const hasRandomAbbreviatedOrgName = (orgId: string): boolean =>
  /^[a-z]{2,}_/.test(orgId);

const hasRandom8CharacterString = (orgId: string): boolean =>
  /_[a-z0-9]{8}$/.test(orgId);

const hasOnlyLowerCaseNumbersAndUnderscores = (orgId: string): boolean =>
  /^[a-z0-9_]+$/.test(orgId);

export const validateOrganizationId = (orgId: string): boolean =>
  hasRandomAbbreviatedOrgName(orgId) &&
  hasRandom8CharacterString(orgId) &&
  hasOnlyLowerCaseNumbersAndUnderscores(orgId);

export const invalidOrgIdMsg =
  'id must start with a string of alphanumeric characters of at least' +
  ' 2 characters in length (lowercase letters, numbers, and underscores allowed)' +
  ' and end with an underscore followed by a random 8 alphanumeric string.';

export const validateOrgIdPrefix = (orgId: string): boolean =>
  /^[a-zA-Z0-9_ ]{2,}$/.test(orgId);

export const invalidOrgIdPrefixMsg =
  'id prefix must contain at least 2 characters; only ' +
  ' alphanumeric characters, spaces, and underscores are allowed.';
